import { Routes, Route } from "react-router-dom";
import "./App.css";
import React from "react";
import TmisDashboard from "./pages/TmisDashboard";
import Performance from "./pages/Performance";
import PerformanceTemplate from "./pages/PerformanceTemplate";
import Login from "./pages/Login";
import ViewPerformanceTemplate from "./pages/ViewPerformanceTemplate";
import PreviewAssessmentPage from "./pages/PreviewAssessmentPage";
import AuditLogs from "./pages/AuditLogs";

function App() {
  return (
    <Routes>
      <Route path="/" element={<Login />} />
      <Route path="/dashboard" element={<TmisDashboard />} />
      <Route path="/performance" element={<Performance />} />
      <Route path="/performanceTemplate" element={<PerformanceTemplate />} />
      <Route path="/template" element={<ViewPerformanceTemplate />} />
      <Route path="/previewAssessment" element={<PreviewAssessmentPage />} />
      <Route path="/audit-logs" element={<AuditLogs />} />
    </Routes>
  );
}

export default App;
